import { useLanguageTranslator } from "hooks/use-language-translator";
import styles from "./styles.module.scss";
import { ConditionalRenderer } from "components";

export function PrefixInsideInput({ item, label }) {
  const { translator } = useLanguageTranslator();

  return (
    <div
      className={styles.prefix}
      style={{
        marginLeft:
          item?.type === "dropdown" || item?.type === "date" ? "10px" : "",
      }}
    >
      {item?.prefixIcon ? <item.prefixIcon /> : null}
      <ConditionalRenderer condition={item?.key}>
        <h4>{translator(`caseDetail.form.${item?.key}`)}:</h4>
      </ConditionalRenderer>
      <ConditionalRenderer condition={label}>
        <div className={styles.readOnlyParentLabel}>{label}:</div>
      </ConditionalRenderer>
    </div>
  );
}
